import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./login";
import Register from "./register";
import ForgotPassword from "./forgotPass";
import GuardRoute from "./guard";
import Layout from "../components/layout/Layout";
import { routes } from "./routes";
import Dashboard from "./dashboard";
import Yard from "./yard";
import Home from "./Home";
import Trainings from "./trainings";
import Comparaison from "./comparaison";
import Analytics from "./analytics";
import EmailSent from "./email-sent";
import GeneratePassword from "./generate-password";
import ResetPassword from "./email-sent/ResetPassword";
import User from "./user";
import Profile from "./user/Profile";
import Settings from "./user/Settings";
import Shoeing from "./user/Shoeing";
import Riders from "./user/Riders";
import TracksConditions from "./user/TracksConditions";
import Tracks from "./user/Tracks";
import TrackView from "./user/TrackView";
import ExamView from "./trainings/ExamView";
import MyTrainings from "./user/MyTrainings";
import Notifications from "./settings/notifications";
import ExternalComparaison from "./comparaison/ExternalComparaison";
import AnalyticTable from "./user/AnalyticTable";
import Unsubscribe from "./unsubscribe";
import GuestGuard from "./guard/GuestGuard";
import MyTrainingTypes from "./user/MyTrainingTypes";
import Horse from "./horse";
import ExternalTraining from "./trainings/ExternalTraining";
import Billings from "./user/Billings";
import Page from "../components/layout/Helmet";
import { t } from "i18next";
import Qualifications from "./user/qualifications";
import MyEquimetres from "./user/MyEquimetres";
import Logout from "./logout";
import GallopPreview from "./gallop-preview/Index";
import { Container } from "@mui/material";
import StableReview from "./stable-review";
import LegalNotice from "./public/legalNotice";
import DataProtection from "./public/dataProtection";
import DataSuccess from "./dataSuccess";
import Onboarding from "./user/Onboarding";
import { UserActivityLogProvider } from "../hooks/useUserActivityLog";
import TrainingsPreview from "./trainings-pdf/TrainingsPreview";
import Mantainance from "./mantainance";
import MyEqmFleet from "./user/MyEqmFleet";
import EqmRedirection from "./user/EqmRedirection";
export const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  {
    path: routes.AUTH_ROUTES.LOGIN,
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  {
    path: routes.AUTH_ROUTES.LOGOUT,
    element: (
      <GuardRoute>
        <Logout />
      </GuardRoute>
    ),
  },
  {
    path: routes.AUTH_ROUTES.REGISTER,
    element: (
      <GuestGuard>
        <Register />
      </GuestGuard>
    ),
  },
  {
    path: routes.AUTH_ROUTES.EMAIL_SENT,
    element: (
      <GuestGuard>
        <EmailSent />
      </GuestGuard>
    ),
  },
  {
    path: routes.AUTH_ROUTES.EMAIL_SENT_PASSWORD,
    element: (
      <GuestGuard>
        <ResetPassword />
      </GuestGuard>
    ),
  },
  {
    path: routes.AUTH_ROUTES.GENERATE_PASSWORD,
    element: (
      <GuestGuard>
        <GeneratePassword />
      </GuestGuard>
    ),
  },
  {
    path: routes.AUTH_ROUTES.FORGOT_PASSWORD,
    element: (
      <GuestGuard>
        <ForgotPassword />
      </GuestGuard>
    ),
  },
  {
    path: routes.OTHER_ROUTES.UNSUBSCRIBE,
    element: <Unsubscribe />,
  },
  {
    path: routes.OTHER_ROUTES.MANTAINANCE,
    element: (
      <GuardRoute>
        <Mantainance />
      </GuardRoute>
    ),
  },
  {
    path: "/",
    element: (
      <GuardRoute>
        <Dashboard />
      </GuardRoute>
    ),
    children: [
      {
        path: "",
        element: <Navigate to={routes.DASHBOARD_ROUTES.HOME} replace />,
      },
      {
        path: routes.DASHBOARD_ROUTES.YARD,
        element: (
          <GuardRoute>
            <Yard />
          </GuardRoute>
        ),
      },

      {
        path: routes.DASHBOARD_ROUTES.HOME,
        element: (
          <GuardRoute>
            <Home />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.TRAININGS,
        element: (
          <GuardRoute>
            <Trainings />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.COMPARAISON,
        element: (
          <GuardRoute>
            <Comparaison />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.ANALYTICS,
        element: (
          <GuardRoute>
            <Page withNameApp title={"navbar:analytics"}>
              <Analytics />
            </Page>
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.DATA_SUCCESS,
        element: (
          <GuardRoute>
            <DataSuccess />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.EXAM_VIEW,
        element: (
          <GuardRoute>
            <ExamView />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.HORSE_VIEW,
        element: (
          <GuardRoute>
            <Horse />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.PROFILE,
        element: (
          <GuardRoute>
            <Profile />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.EQUIMETRES,
        element: (
          <GuardRoute>
            <EqmRedirection />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.BILLINGS,
        element: (
          <GuardRoute>
            <Billings />
          </GuardRoute>
        ),
      },
      {
        path: routes.DASHBOARD_ROUTES.USER,
        element: (
          <GuardRoute>
            <User />
          </GuardRoute>
        ),
        children: [
          {
            path: routes.DASHBOARD_ROUTES.SETTINGS,
            element: (
              <GuardRoute>
                <Settings />
              </GuardRoute>
            ),
          },
          {
            path: routes.DASHBOARD_ROUTES.NOTIFICATIONS,
            element: (
              <GuardRoute>
                <Notifications standalone={false} />
              </GuardRoute>
            ),
          },

          {
            path: routes.DASHBOARD_ROUTES.MYTRAININGS,
            element: (
              <GuardRoute>
                <MyTrainings />
              </GuardRoute>
            ),
          },
          {
            path: routes.DASHBOARD_ROUTES.MYANALYTICS,
            element: (
              <GuardRoute>
                <AnalyticTable />
              </GuardRoute>
            ),
          },
          {
            path: routes.DASHBOARD_ROUTES.QUALIFICATION,
            element: (
              <GuardRoute>
                <Qualifications />
              </GuardRoute>
            ),
            children: [
              {
                path: routes.DASHBOARD_ROUTES.TRACKS,
                element: (
                  <GuardRoute>
                    <Tracks />
                  </GuardRoute>
                ),
              },
              {
                path: routes.DASHBOARD_ROUTES.SHOEING,
                element: (
                  <GuardRoute>
                    <Shoeing />
                  </GuardRoute>
                ),
              },
              {
                path: routes.DASHBOARD_ROUTES.RIDERS,
                element: (
                  <GuardRoute>
                    <Riders />
                  </GuardRoute>
                ),
              },
              {
                path: routes.DASHBOARD_ROUTES.TRACKSCONDITIONS,
                element: (
                  <GuardRoute>
                    <TracksConditions />
                  </GuardRoute>
                ),
              },
              {
                path: routes.DASHBOARD_ROUTES.TRAININGTYPE,
                element: (
                  <GuardRoute>
                    <MyTrainingTypes />
                  </GuardRoute>
                ),
              },
              {
                path: routes.DASHBOARD_ROUTES.TRACK_VIEW,
                element: (
                  <GuardRoute>
                    <TrackView />
                  </GuardRoute>
                ),
              },
            ],
          },
          {
            path: routes.DASHBOARD_ROUTES.ONBOARDING,
            element: (
              <GuardRoute>
                <Onboarding />
              </GuardRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/settings",
    children: [
      {
        path: routes.SETTINGS_ROUTES.PDF,
        element: (
          <div className="app-bg">
            <Container sx={{ py: 5 }}>
              <Notifications></Notifications>
            </Container>
          </div>
        ),
      },
    ],
  },
  {
    path: "/pdf",
    children: [
      {
        path: routes.PDF_ROUTES.COMPARAISON,
        element: (
          <UserActivityLogProvider>
            <ExternalComparaison></ExternalComparaison>
          </UserActivityLogProvider>
        ),
      },
      {
        path: routes.PDF_ROUTES.TRAINING,
        element: (
          <UserActivityLogProvider>
            <ExternalTraining></ExternalTraining>
          </UserActivityLogProvider>
        ),
      },
      {
        path: routes.PDF_ROUTES.GALLOP,
        element: (
          <UserActivityLogProvider>
            <GallopPreview></GallopPreview>
          </UserActivityLogProvider>
        ),
      },
      {
        path: routes.PDF_ROUTES.TRAININGS,
        element: (
          <UserActivityLogProvider>
            <TrainingsPreview></TrainingsPreview>
          </UserActivityLogProvider>
        ),
      },
      {
        path: routes.PDF_ROUTES.STABLE,
        element: (
          <UserActivityLogProvider>
            <StableReview></StableReview>
          </UserActivityLogProvider>
        ),
      },
    ],
  },
  {
    path: "/public",
    children: [
      {
        path: routes.PUBLIC_ROUTES.legalNotice,
        element: <LegalNotice />,
      },
      {
        path: routes.PUBLIC_ROUTES.dataProtection,
        element: <DataProtection />,
      },
    ],
  },
]);
